module.exports = __webpack_public_path__ + "img/login_logo.c63933bb.png";